/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.18.0
 * @since 1.17.0
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./PageAutoReportIdRoute'));
